import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ValidMe } from '../../../../businessLogic/validation.js';
import { AfterCallCanSeeOptions } from 'businessLogic/afterCallOption.js';
import Txt from '../../../inputs/textInput.js';
import { updateMeetingRoomForm } from '../../../../actions/meetingRoom';
import objectAssign from 'object-assign';
import { Dropdown } from 'semantic-ui-react';

export default function CenterPanel(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    // Set defaultCallQuality & networkId from portal setting to meetingRoomForm
    let updatedMeetingRoomForm = objectAssign({}, props.meetingRoomForm, {
      id: props.organisation.networkId,
      videoCallQualityId: props.defaultCallQuality,
    });
    dispatch(updateMeetingRoomForm(updatedMeetingRoomForm));

    window.addEventListener('globalMessageHidden', globalMessageHidden);

    return () => {
      window.removeEventListener('globalMessageHidden', globalMessageHidden);
    };
  }, []);

  //this function is a delegate event, and is fired when global message is hidden
  const globalMessageHidden = (e) => {
    if (e.detail && e.detail.text.indexOf('Meeting Room with that name') > 0) {
      window.$('input[name="meetingRoomName"]').focus();
    }
  };
  const changeCallQuality = (event, data) => {
    dispatch(updateMeetingRoomForm(meetingRoomFormUpdated('videoCallQualityId', data.value)));
  };
  const meetingRoomNameChanged = (value) => {
    dispatch(updateMeetingRoomForm(meetingRoomFormUpdated('name', value)));
  };

  const meetingRoomFormUpdated = (property, value) => {
    return objectAssign({}, props.meetingRoomForm, { [property]: value });
  };

  const changePostCallOption = (event, data) => {
    let resetAfterCallForm = {
      callProviderUrl: props.meetingRoomForm.callProviderUrl,
      callerGuestUrl: props.meetingRoomForm.callerGuestUrl,
      postCallUrl: props.meetingRoomForm.postCallUrl,
      postCallOption: data.value,
    };
    let updatedAfterCallsForm = objectAssign({}, props.meetingRoomForm, resetAfterCallForm);

    dispatch(updateMeetingRoomForm(updatedAfterCallsForm));
  };

  const postCallUrlChanged = (value) => {
    dispatch(updateMeetingRoomForm(meetingRoomFormUpdated('postCallUrl', value)));
  };

  const callProviderUrlChanged = (value) => {
    dispatch(updateMeetingRoomForm(meetingRoomFormUpdated('callProviderUrl', value)));
  };

  const callerGuestUrlChanged = (value) => {
    dispatch(updateMeetingRoomForm(meetingRoomFormUpdated('callerGuestUrl', value)));
  };

  let foundQualityOption = props.callQualityOptions.find((callQualityOption) => {
    return callQualityOption.value == props.defaultCallQuality;
  });

  const renderUrlForOption2 = () => {
    return props.meetingRoomForm.postCallOption === 1 ? (
      <div>
        <ValidMe validmefor="httpOrHttpsURL@canBeEmpty" group="createMRForm" fieldClasses="mrtl">
          <Txt
            tabIndex="4"
            focusme="true"
            value={props.meetingRoomForm?.postCallUrl || ''}
            titlePlaceholder={APP.LANGUAGE.CreateUpdateMeetingRoom.SameInformationSurvePageLabel}
            placeholder={APP.LANGUAGE.CreateUpdateMeetingRoom.URLPlaceholder}
            noTitle
            onChange={(value) => postCallUrlChanged(value)}
          />
        </ValidMe>
        <label className="placeholder-label no-bold color-placeholder div-like">
          {APP.LANGUAGE.CreateUpdateMeetingRoom.PostCallURLLeaveBlankForOption2}
        </label>
      </div>
    ) : (
      ''
    );
  };

  const renderUrlForOption3 = () => {
    return props.meetingRoomForm.postCallOption === 2 ? (
      <div>
        <ValidMe validmefor="httpOrHttpsURL@canBeEmpty" group="createMRForm" fieldClasses="mrtl">
          <Txt
            tabIndex="4"
            focusme="true"
            value={props.meetingRoomForm?.callProviderUrl || ''}
            titlePlaceholder={APP.LANGUAGE.CreateUpdateMeetingRoom.DifferentSurveyGroupMemberUrl}
            placeholder={APP.LANGUAGE.CreateUpdateMeetingRoom.URLPlaceholder}
            noTitle
            onChange={(value) => callProviderUrlChanged(value)}
          />
        </ValidMe>
        <ValidMe validmefor="httpOrHttpsURL@canBeEmpty" group="createMRForm" fieldClasses="mrtl">
          <Txt
            tabIndex="5"
            value={props.meetingRoomForm?.callerGuestUrl || ''}
            placeholder={APP.LANGUAGE.CreateUpdateMeetingRoom.URLPlaceholder}
            titlePlaceholder={APP.LANGUAGE.CreateUpdateMeetingRoom.DifferentSurveyOtherParticipant}
            noTitle
            onChange={(value) => callerGuestUrlChanged(value)}
          />
        </ValidMe>
        <label className="placeholder-label no-bold color-placeholder div-like">
          {APP.LANGUAGE.CreateUpdateMeetingRoom.PostCallURLLeaveBlankForOption3}
        </label>
      </div>
    ) : (
      ''
    );
  };

  return (
    <div className="ui form mrbml">
      <div className="pdts">
        <ValidMe
          validmefor="length@3-50"
          validmemessage={APP.LANGUAGE.Errors.MeetingRoomValidNameLength}
          trim={true}
          group="createMRForm"
        >
          <Txt
            tabIndex="1"
            maxLength={50}
            focusme="true"
            noTitle
            name="meetingRoomName"
            value={props.meetingRoomForm.name}
            onChange={(value) => meetingRoomNameChanged(value)}
            placeholder={APP.LANGUAGE.CreateUpdateMeetingRoom.NamePlaceholder}
          />
        </ValidMe>
      </div>
      <div className="pdts">
        <div>
          <div className="placeholder-label no-bold div-like color-placeholder">
            {APP.LANGUAGE.CreateUpdateMeetingRoom.CallQualityLabel}
          </div>
          <Dropdown
            tabIndex="2"
            defaultValue={foundQualityOption.value}
            onChange={(event, data) => changeCallQuality(event, data)}
            fluid
            selection
            options={props.callQualityOptions}
          />
        </div>
      </div>
      <div className="pdts">
        <label className="placeholder-label no-bold color-placeholder div-like">
          {APP.LANGUAGE.CreateUpdateMeetingRoom.SelectedSurveyOptionLabel}
        </label>
        <Dropdown
          tabIndex="3"
          className="after-call-dropdown"
          defaultValue={props.meetingRoomForm.postCallOption}
          onChange={(event, data) => changePostCallOption(event, data)}
          fluid
          selection
          options={AfterCallCanSeeOptions}
        />
        {renderUrlForOption2()}
        {renderUrlForOption3()}
      </div>
      <div className="mrbxxl hide-on-small-ress " />
    </div>
  );
}
